import { useEffect, useState } from "react";
import "./certs.scss"
import { certs } from "../../data";


function Certs(props) {
    const [selected, setSelected] = useState("certs");
    const [data, setData] = useState([]);
    const [currentSlider, setCurrentSlider] = useState(0)

    useEffect(() => {
        switch (selected) {
            case "certs":
                setData(certs);
                break;
        }
    }, [selected]);

    const handleClick = (way) => {
        way === "left"
            ? setCurrentSlider(currentSlider > 0 ? currentSlider - 1 : 1)
            : setCurrentSlider(currentSlider < data.length - 1 ? currentSlider + 1 : 0)
    }

    return (
        <div className='certs' id="certs">
            <h1>Certificates</h1>
            <div className="slider" style={{ transform: `translateX(-${currentSlider * 100}vw)` }}>
                {data.map((d) => (
                    <div className="container">
                        <div className="item">
                            <div className="right">
                                <img src={d.img} alt="" />
                            </div>
                        </div>
                    </div>
                ))
                }
            </div>
            <img src="assets/down arrow.png" className="arrow left" alt="" onClick={() => handleClick("left")} />
            <img src="assets/down arrow.png" className="arrow right" alt="" onClick={() => handleClick()} />
        </div>
    );
}

export default Certs;
